function hoursTextFromMinutes(minutes) {
  const hours = minutes / 60;
  return Number.isInteger(hours)
    ? `${hours} Std.`
    : `${hours.toLocaleString('de-DE', { maximumFractionDigits: 2 })} Std.`;
}

export function remainingHoursLabel(remainingUnits, unitMinutes) {
  const units = Math.max(Number(remainingUnits) || 0, 0);
  const minutes = units * Math.max(Number(unitMinutes) || 0, 0);
  if (units === 0) return '0 Einheiten übrig';
  return `${units} Einheit${units === 1 ? '' : 'en'} übrig (${hoursTextFromMinutes(minutes)})`;
}

export function remainingHoursLabelFromTotals(remainingUnits, remainingMinutes) {
  const units = Math.max(Number(remainingUnits) || 0, 0);
  if (units === 0) return '0 Einheiten übrig';
  const minutes = Math.max(Number(remainingMinutes) || 0, 0);
  return `${units} Einheit${units === 1 ? '' : 'en'} übrig (${hoursTextFromMinutes(minutes)})`;
}

export function cardStandLabel(card) {
  const used = Number(card?.used_units) || 0;
  const total = Number(card?.total_units) || 0;
  const left = Number(card?.remaining_units ?? (total - used)) || 0;
  return `${used}/${total} verbraucht · ${left} übrig`;
}
